module.exports = __webpack_public_path__ + "img/RoomImage.5309dc4b.svg";